import { render, staticRenderFns } from "./DDSReportsByStatusCard.vue?vue&type=template&id=012af266&scoped=true"
import script from "./DDSReportsByStatusCard.vue?vue&type=script&lang=js"
export * from "./DDSReportsByStatusCard.vue?vue&type=script&lang=js"
import style0 from "./DDSReportsByStatusCard.vue?vue&type=style&index=0&id=012af266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012af266",
  null
  
)

export default component.exports